import { useState } from 'react';
import Validator from 'validatorjs';
import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';

import { FormControl } from '../../../../../facturotopia/index.js';

const IngresosOEntradasForm = (props) => {
  const data = props.data;
  const [, setValidator] = useState({
    isValid: false,
    validator: new Validator(),
  });

  const handleOnChange = (event) => {
    const validator = validate({
      ...props.data,
      ...event,
    });

    props.onFormDataChange(event, {
      step: 'base',
      name: 'isValidIngresosOEntradas',
      isValid: validator.passes(),
    });
  };

  const getRules = (data) => {
    return {
      MontTotEntradasPeriodo: ['required', 'decimal:6'],
      PartPropAcumDelFideicom: ['required', 'decimal:6'],
      PropDelMontTot: ['required', 'regex:/^\\d{1,10}\\.\\d{0,6}$/'],
      Concepto: ['required', 'string', 'min:1', 'max:100'],
    };
  };

  const validate = (data) => {
    const validator = new Validator(data, getRules(data));

    const newValidator = {
      validator: validator,
      isValid: validator.passes(),
    };

    setValidator(newValidator);

    return validator;
  };

  const rules = getRules(data);

  return (
    <Form autoComplete="off">
      <Row>
        <Col
          sm
          md={3}
        >
          <FormControl
            type="number"
            label="Monto total ingresos"
            name="MontTotEntradasPeriodo"
            placeholder=""
            help=""
            rules={rules.MontTotEntradasPeriodo}
            value={data.MontTotEntradasPeriodo}
            onChange={handleOnChange}
          />
        </Col>
        <Col
          sm
          md={3}
        >
          <FormControl
            type="number"
            label="Parte proporcional acumulable"
            name="PartPropAcumDelFideicom"
            placeholder=""
            help=""
            rules={rules.PartPropAcumDelFideicom}
            value={data.PartPropAcumDelFideicom}
            onChange={handleOnChange}
          />
        </Col>
        <Col
          sm
          md={3}
        >
          <FormControl
            type="number"
            label="Proporción del monto total"
            name="PropDelMontTot"
            placeholder=""
            help=""
            rules={rules.PropDelMontTot}
            value={data.PropDelMontTot}
            onChange={handleOnChange}
          />
        </Col>
        <Col
          sm
          md={12}
        >
          <FormControl
            as="textarea"
            label="Descripción del concepto"
            name="Concepto"
            placeholder=""
            help=""
            minLength="1"
            maxLength="100"
            rules={rules.Concepto}
            value={data.Concepto}
            onChange={handleOnChange}
          />
        </Col>
      </Row>
    </Form>
  );
};

export default IngresosOEntradasForm;
